export const notice = (contractor: any) => {
  return [
    { text: `     17. NOTICE`, bold: true, style: 'p' },

    { text: ` All notices given or required to be given hereunder may be sent by facsimile or any type of U.S. Mail or email as follows:`, style: 'p' },

    {
      columns: [
        {
          width: '40%',
          text: [
            { text: 'INDEPENDENT CONTRACTOR:', bold: true, color: '#058ff4' },
            { text: '\n' },  // Line break
            { text: 'Name: ', bold: true },
            { text: `${contractor.name}` },
            { text: '\n' },  // Line break
            { text: 'Address: ', bold: true },
            { text: `${contractor.address}` },
            { text: '\n' },  // Line break
            { text: 'Phone: ', bold: true },
            { text: `${contractor.phone}` },
            { text: '\n' },  // Line break
            { text: 'Fax: ', bold: true },
            { text: contractor.fax ? contractor.fax : '____________________' },
            { text: '\n' },  // Line break
            { text: 'Email: ', bold: true },
            { text: `${contractor.email}` },
            { text: '\n' },  // Line break
          ],
        },

        {
          width: '60%',
          text: [
            { text: 'COMPANY:', bold: true, color: '#058ff4' },
            { text: '\n' },  // Line break
            { text: 'Sierra Expediting Inc.', bold: true },
            { text: '\n' },  // Line break
            { text: 'Address: ', bold: true },
            { text: '403 North Airport Rd, Strafford, MO 65757, Unit B' },
            { text: '\n' },  // Line break
            { text: 'Phone: ', bold: true },
            { text: '(916) 818-0800' },
            { text: '\n' },  // Line break
            { text: 'Fax: ', bold: true },
            { text: '(916) 818-0808' },
            { text: '\n' },  // Line break
            { text: 'Email: ', bold: true },
            { text: 'safety@sierraexpedite.com' },
            { text: '\n' },  // Line break
          ],
        },
      ],
      style: 'p',
    },
  ];
};
